<template>
  <div id="app">
    <nav-bar />
    <div id="router-view">
      <router-view />
    </div>
    <v-footer />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import NavBar from '@/components/NavBar.vue'
import VFooter from '@/components/VFooter.vue'

@Component({ components: { NavBar, VFooter } })
export default class App extends Vue {

}
</script>

<style lang="scss">
@import '@/assets/scss/fonts.scss';
@import '@/assets/scss/colors.scss';

#app {
  .align-right {
    text-align: right;
  }
  #router-view {
    min-height: calc(100vh - 84px - 284px);
  }
  background: url('./assets/icons/wolk-1.svg') right top no-repeat;
  background-size: 40vw;
  min-height: 100vh;
  button:focus {
    outline: none;
  }
  .material-design-icon {
    svg {
      vertical-align: bottom;
    }
  }
  .lime-icon {
    cursor: pointer;
    margin-right: 8px;
    width: 38px;
    height: 38px;
    background-color: $airlearn-lime;
    border-radius: 19px;
    svg {
      color: white;
      width: 20px;
    }
    &.input-icon {
      svg {
        height: 24px;
        width: 24px;
      }
      cursor: pointer;
      margin-left: -34px;
      margin-top: 4px;
      width: 30px;
      height: 30px;
      border-radius: 15px;
    }
  }
  .max-350 {
    max-width: 350px;
  }
  .content-maxed {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }
  .content {
    .w3-row:not(.promo-belt) {
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .flexer {
    display: flex;
    flex-wrap: wrap;
  }
  .loading-container {
    height: 60px;
  }
}
</style>
